<template>
  <div>
    <div class="div-main">
      <div class="div-name">
        <label class="title">{{ pageTitle }}</label>
      </div>
      <div>
        <img class="img-main" :src='icon'/>
      </div>
      <p class="end-p" v-show="false">{{ browseName }} --- {{ ua }}</p>
      <div v-if="!showProgress">
        <p v-if="showDownload2" style="margin-top: 10px">
          <a :href="apkPath" :download="apkName" class="title2">{{ t.download }}</a>
        </p>
        <el-button v-else type="primary" round @click.native="downloadCountAdd()">{{ t.download }}</el-button>
      </div>
      <div v-else>
        <el-progress type="circle" :percentage="progress" :stroke-width="10"
                     class="custom-progress"
                     :format="formatProgress"
        ></el-progress>
        <p class="end-p">{{ t.packaging }}</p>
      </div>
      <p v-if="progress===100" class="end-p">{{ t.packageSuccess }}</p>
      <p v-if="showDownloadError" class="end-error">
        {{ t.packageError1 }}<br/>{{ t.packageError2 }}
      </p>
    </div>
    <p class="end-p">
      {{ t.copyright1 }}<br/>{{ t.copyright2 }}
    </p>
  </div>
</template>

<script>

const I18N = {
  zh: {
    download: '下载',
    packaging: '正在打包中，请耐心等候...',
    packageSuccess: '打包成功，稍作等待，浏览器正在识别下载内容',
    packageError1: '打包失败，请重新打包。',
    packageError2: '如多次尝试后仍存在错误，请联系服务器管理员。',
    copyright1: '© 2003-2020 慧源创新科技 Cloud 版权所有',
    copyright2: '粤ICP备18095928号',
    notice: '提示',
    iKnow: '我知道了',
    harmonyTip: '检测到您使用的是鸿蒙系统（HarmonyOS NEXT），该系统暂不支持直接安装安卓 APK 文件。',
    wechatTip: '微信内无法直接下载 APK，请点击右上角「···」选择「在浏览器打开」来下载。'
  },
  en: {
    download: 'Download',
    packaging: 'Packaging, please wait...',
    packageSuccess: 'Packaging completed. The browser is now detecting the download content...',
    packageError1: 'Packaging failed. Please try again.',
    packageError2: 'If the problem persists, please contact the server administrator.',
    copyright1: '© 2003-2020 慧源创新科技 Cloud . All rights reserved.',
    copyright2: '粤ICP备18095928号',
    notice: 'Notice',
    iKnow: 'Got it',
    harmonyTip: 'HarmonyOS NEXT detected. This system does not support installing Android APK files directly.',
    wechatTip: 'APK cannot be downloaded inside WeChat. Please tap "···" in the top-right corner and choose "Open in browser" to download.'
  }
}

const LANG_STORAGE_KEY = 'hyAppView_lang'

export default {
  name: 'Model',
  data () {
    return {
      name: '',
      icon: '',
      apkPath: '',
      apkName: '',
      alignApkPath: '',
      browseName: '',
      isDownloading: false,
      isPaused: false,
      progress: 0,
      fileSize: 0,
      chunkSize: 1 * 1024 * 1024, // 5MB
      chunks: [],
      controller: null,
      downloadedSize: 0,
      showProgress: false,
      showDownloadError: false,
      ua: '',
      test: false,
      showDownload2: false,
      lang: 'zh'
    }
  },
  computed: {
    t () {
      return I18N[this.lang] || I18N.zh
    },
    displayName () {
      if (this.lang === 'en' && this.$route.query.nameEn) {
        return this.$route.query.nameEn
      }
      return this.name
    },
    pageTitle () {
      return this.lang === 'en' ? `${this.displayName} Download` : `${this.displayName}下载`
    }
  },
  created () {
    var html = document.getElementsByTagName('html')[0]
    if (window.innerWidth < 768) {
      html.style.fontSize = window.innerWidth / 750 * 100 + 'px'
    } else {
      html.style.fontSize = '16px'
    }
    window.addEventListener('resize', function () {
      if (window.innerWidth < 768) {
        html.style.fontSize = window.innerWidth / 750 * 100 + 'px'
      } else {
        html.style.fontSize = '16px'
      }
    })

    this.name = this.$route.query.name
    this.icon = this.$global.baseURL.concat(this.$route.query.icon)

    this.apkPath = this.$global.baseURL.concat(this.$route.query.apkPath).replace(':8084', '')
    this.apkPath = this.testLocalUrl(this.apkPath)
    this.alignApkPath = this.$global.baseURL.concat('downloadFile/apk?filename=').concat(this.$route.query.apkPath)
    this.alignApkPath = this.testLocalUrl(this.alignApkPath)

    this.browseName = this.detectMobileBrowser()
    this.showDownload2 = this.browseName !== 'Unknown'
    this.apkName = this.apkPath.substring(this.apkPath.lastIndexOf('/') + 1)

    this.initLang()
  },
  methods: {
    initLang () {
      const qLang = (this.$route.query.lang || '').toLowerCase()
      let saved = ''
      try {
        saved = (localStorage.getItem(LANG_STORAGE_KEY) || '').toLowerCase()
      } catch (e) {}

      let lang = ''
      if (qLang) {
        lang = qLang.indexOf('en') === 0 ? 'en' : 'zh'
      } else if (saved === 'en' || saved === 'zh') {
        lang = saved
      } else {
        const navLang = (navigator.language || navigator.userLanguage || 'zh').toLowerCase()
        lang = navLang.indexOf('zh') === 0 ? 'zh' : 'en'
      }
      this.lang = lang
      this.applyLang()
    },
    applyLang () {
      document.documentElement.setAttribute('lang', this.lang === 'en' ? 'en' : 'zh-CN')
      document.title = this.pageTitle
    },
    switchLang (lang) {
      if (this.lang === lang) return
      this.lang = lang
      try {
        localStorage.setItem(LANG_STORAGE_KEY, lang)
      } catch (e) {}
      this.applyLang()
    },

    testLocalUrl (url) {
      if (this.test) {
        return url.replace('127.0.0.1', '192.168.0.128')
          .replaceAll(':8080', '')
          .replace('http:', 'https:')
      } else {
        return url
      }
    },
    detectMobileBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      this.ua = ua
      const brands = [
        {name: 'Huawei', pattern: /huaweibrowser|hwbrowser/},
        {name: 'Xiaomi', pattern: /miuibrowser|xiaomi|redmi/},
        {name: 'OPPO', pattern: /heytapbrowser/},
        {name: 'Realme', pattern: /rmx\d+/},
        {name: 'vivo', pattern: /vivobrowser|vivo/},
        {name: 'OnePlus', pattern: /oneplus/},
        {name: 'Honor', pattern: /honorbrowser/},
        {name: 'Windows ', pattern: /windows/}
      ]
      for (const brand of brands) {
        if (brand.pattern.test(ua)) return brand.name
      }
      return 'Unknown'
    },
    isWeChatBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      return /micromessenger/.test(ua) && /android/.test(ua)
    },
    isHarmonyOS () {
      const ua = navigator.userAgent.toLowerCase()
      if (/harmonyos|openharmony/.test(ua)) {
        return true
      }
      return false
    },
    downloadCountAdd () {
      console.log('downloadCountAdd:this.isHarmonyOS()/isWeChatBrowser()  ', this.isHarmonyOS(), this.isWeChatBrowser())
      if (this.isHarmonyOS()) {
        this.$confirm(
          this.t.harmonyTip,
          this.t.notice,
          {
            confirmButtonText: this.t.iKnow,
            showCancelButton: false,
            type: 'warning'
          }
        ).then(() => {}).catch(() => {})
        return
      }
      if (this.isWeChatBrowser()) {
        this.$confirm(this.t.wechatTip, this.t.notice, {
          confirmButtonText: this.t.iKnow,
          showCancelButton: false,
          type: 'warning'
        }).then(() => {}).catch(() => {})
        return
      }

      console.log('downloadCountAdd', this.apkName)
      this.clickADownloadPhone()

      this.$axios({
        url: this.$global.baseURL.concat('main/downloadCountAdd'),
        method: 'post',
        data: {url: this.apkPath}
      }).then(successResponse => {
        // this.downloadApkPath()
      })
    },
    formatProgress (progress) {
      return `${progress.toFixed(2)}%`
    },
    clickADownloadIFrame () {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = this.apkPath
      document.body.appendChild(iframe)
    },
    clickADownloadPhone () {
      let downloadElement = document.createElement('a')
      downloadElement.setAttribute('type', 'application/vnd.android.package-archive')
      downloadElement.href = this.apkPath
      downloadElement.download = this.apkName || 'app.apk'
      downloadElement.target = '_blank'
      downloadElement.setAttribute('download', this.apkName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
    },
    clickADownloadBrowse () {
      console.log('downloadCountAdd')
      let downloadElement = document.createElement('a')
      downloadElement.setAttribute('type', 'application/vnd.android.package-archive')
      downloadElement.href = this.apkPath
      downloadElement.download = this.apkName
      document.body.appendChild(downloadElement)
      downloadElement.click()
      setTimeout(() => {
        document.body.removeChild(downloadElement)
      }, 100)
    },
    async startDownload () {
      this.isDownloading = true
      this.showDownloadError = false
      this.isPaused = false
      this.progress = 0
      this.chunks = []
      this.downloadedSize = 0

      try {
        const fileSize = await this.getFileSize()
        this.fileSize = fileSize
        const totalChunks = Math.ceil(fileSize / this.chunkSize)
        this.controller = new AbortController()
        const promises = []
        for (let i = 0; i < totalChunks; i++) {
          const start = i * this.chunkSize
          const end = Math.min(start + this.chunkSize - 1, fileSize - 1)
          promises.push(this.downloadChunk(start, end, i))
        }
        await Promise.all(promises)
        await this.mergeChunks()
        if (this.progress === 100) {
          this.showProgress = false
        }
      } catch (error) {
        console.error('下载失败:', error)
        this.showProgress = false
        this.showDownloadError = true
      } finally {
        this.isDownloading = false
      }
    },
    async getFileSize () {
      const response = await fetch(this.$global.baseURL.concat('downloadFile/fileSize?filename=').concat(this.$route.query.apkPath), {
        method: 'HEAD'
      })
      if (!response.ok) {
        throw new Error('无法获取文件信息')
      }
      const contentLength = response.headers.get('Content-Length')
      if (!contentLength) {
        throw new Error('无法获取文件大小')
      }
      return parseInt(contentLength)
    },
    async downloadChunk (start, end, index) {
      if (this.isPaused) {
        return
      }
      const response = await fetch(this.$global.baseURL.concat('downloadFile/apk?filename=').concat(this.$route.query.apkPath), {
        headers: {
          'Range': `bytes=${start}-${end}`
        },
        signal: this.controller.signal
      })
      if (!response.ok) {
        this.isPaused = true
        throw new Error(`分片${index}下载失败`)
      }
      const blob = await response.blob()
      this.chunks[index] = blob
      this.downloadedSize += blob.size
      this.progress = Math.min((this.downloadedSize / this.fileSize) * 100, 100)
    },

    async mergeChunks () {
      const sortedChunks = this.chunks
        .filter(chunk => chunk !== undefined)
        .sort((a, b) => {
          return this.chunks.indexOf(a) - this.chunks.indexOf(b)
        })
      const mergedBlob = new Blob(sortedChunks)
      const url = URL.createObjectURL(mergedBlob)
      const a = document.createElement('a')
      a.href = url
      a.download = this.getFileNameFromUrl()
      document.body.appendChild(a)
      a.click()
      setTimeout(() => {
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      }, 100)
    },

    getFileNameFromUrl () {
      return this.apkPath.split('/').pop() || 'downloaded-file'
    },

    cancelDownload () {
      if (this.controller) {
        this.controller.abort()
      }
      this.isDownloading = false
      this.isPaused = false
    }
  },
  beforeDestroy () {
    this.cancelDownload()
  }
}

</script>

<style scoped>
.div-main{
  border:1px solid #66CCFF;
  border-radius: 20px;
  width: 94%;
  margin-top: 20%;
  margin-left: 3%;
  margin-right: 3%;
  text-align: center;
  padding-bottom: 10%;
}
.div-main div{
  text-align: center;
}
.div-name{
  width: 100%;
  height:120px;
  background: #66CCFF;
  text-align: center;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  -moz-border-radius-topleft: 20px;
  -moz-border-radius-topright: 20px;
  padding-top: 60px;
}
.title{
  font-size: 24px;
  color: white;
}
.img-main{
  margin-top: -40px;
  width: 160px;
  height: 160px;
}
.el-button{
  background: #66CCFF;
  border-color: #66CCFF;
  width: 200px;
  font-size: 16px;
}
.el-button:hover{
  background: #1188FF;
  color: white;
}
.end-p{
  font-size: 14px;
  text-align: center;
}
.end-error{
  font-size: 14px;
  text-align: center;
  color: red;
}
.custom-progress{
  margin-top: 10px;
}
.custom-progress >>> .el-progress__text {
  font-size: 24px !important;
}
.title2{
  text-decoration: none;
  color: white;
  padding: 10px 80px 10px 80px;
  font-size: 15px;
  border-radius: 30px;
  background-color: #66CCFF;
  display: inline-block;
  font-weight: bold;
  transition: all 0.3s ease;
}
.title2:hover {
  background-color: #1188FF;
}
.title2:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.lang-switch {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin-top: -6px;
}
.lang-switch span {
  cursor: pointer;
}
.lang-switch .active {
  color: #66CCFF;
  font-weight: bold;
}

.lang-switch .divider {
  margin: 0 8px;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/Model.vue